import type { ReactElement } from 'react';

export interface FilterTileOption {
  id: string;
  label: string;
  count: number;
}

function tileClass(active: boolean): string {
  return `tile ${active ? 'tile-active' : ''}`;
}

export function FilterTiles({
  testId,
  options,
  value,
  onChange
}: {
  testId: string;
  options: FilterTileOption[];
  value: string;
  onChange: (id: string) => void;
}): ReactElement {
  return (
    <section className="tiles-grid" data-testid={testId}>
      {options.map((option) => (
        <article key={option.id} className={tileClass(value === option.id)} onClick={() => onChange(option.id)}>
          <h3>{option.label}</h3>
          <p>{option.count}</p>
        </article>
      ))}
    </section>
  );
}
